import { useCallback } from "react";
import * as overviewService from "../service/overview";
import useOverviewStore from "../store/overview";

export const useGetOverview = () => {
  const { setLoading, setRefreshing, setServices, setVersions } = useOverviewStore();

  const getOverview = useCallback(async () => {
    setLoading(true);
    try {
      const data = await overviewService.get({});
      setServices(data.services);
      setVersions(data.versions);
    } catch (error) {
      console.error("Failed to fetch overview data:", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading, setServices, setVersions]);

  const refreshOverview = useCallback(async () => {
    setRefreshing(true);
    try {
      const data = await overviewService.get({});
      setServices(data.services);
      setVersions(data.versions);
    } catch (error) {
      console.error("Failed to refresh overview data:", error);
    } finally {
      setRefreshing(false);
    }
  }, [setRefreshing, setServices, setVersions]);

  const getByVersion = async (versionId) => {
    setLoading(true);
    try {
      const data = await overviewService.getVersion(versionId);
      setServices(data.services);
    } catch (error) {
      console.error("Failed to fetch version data:", error);
    } finally {
      setLoading(false);
    }
  };

  return { getOverview, refreshOverview, getByVersion };
};
